import type { ProductHit } from '@libs/algolia';
import { getProductById, isNumericSKU } from '@libs/algolia';
import { getProductUrl } from '@libs/common-next';
import type {
    AutocompleteRedirectOject,
    Collections,
    SetAutocompleteStateOptions,
} from './types';

export const mapAlgoliaCollections = (collections: Collections) =>
    collections.map(collection => {
        if (collection.source.sourceId !== 'querySuggestionsPlugin') {
            return collection;
        }

        const { items } = collection;
        const newItems = [];
        let i = 0;

        while (i < items.length) {
            const item = items[i];

            if (item.__autocomplete_qsCategory) {
                // it is guaranteed that if we found a qsCategory, it was for the previous item.
                // ideally I shouldn't have to do this.
                newItems[i - 1].__autocomplete_qsCategory =
                    item.__autocomplete_qsCategory;
                i++;
                continue;
            }

            newItems.push({ ...item });
            i++;
        }

        return {
            ...collection,
            items: newItems,
        };
    });

export const getSectionTitle = (sourceId: string) => {
    switch (sourceId) {
        case 'productSuggestionsPlugin':
            return 'Product results';
        case 'querySuggestionsPlugin':
            return 'Popular searches';
        case 'recentSearchesPlugin':
            return 'Recent searches';
        default:
            return '';
    }
};

export const checkForRedirects = async (
    autocompleteState: SetAutocompleteStateOptions,
    autocompleteQuery: string
) => {
    if (autocompleteState.context.redirectUrlPlugin) {
        const redirectObject: AutocompleteRedirectOject = autocompleteState
            .context.redirectUrlPlugin as unknown as AutocompleteRedirectOject;
        if (
            redirectObject.data &&
            Array.isArray(redirectObject.data) &&
            redirectObject.data.length > 0
        ) {
            const redirect = redirectObject.data[0];
            if (redirect.urls && redirect.urls.length > 0) {
                window.location.href = redirect.urls[0] as string;
                return true;
            }
        }
    }

    const numberfilter = /^\d{7}(?:\d{2})?$/;
    const isPDPFormat = numberfilter.test(autocompleteQuery);
    const isSKU = isNumericSKU(autocompleteQuery);
    const alreadyFound =
        autocompleteState.collections[2] &&
        autocompleteState.collections[2].source.sourceId ===
            'productSuggestionsPlugin' &&
        autocompleteState.collections[2].items &&
        autocompleteState.collections[2].items.length === 1;

    if (isPDPFormat && alreadyFound) {
        window.location.href = getProductUrl(
            autocompleteState.collections[2].items[0] as ProductHit,
            isSKU
        );
        return true;
    }

    if (isPDPFormat && !alreadyFound) {
        const result = await getProductById(autocompleteQuery);

        if (result) {
            window.location.href = getProductUrl(result, isSKU);
            return true;
        }
    }

    return false;
};
